/* istanbul ignore file */
import React from 'react';
import { BreadcrumbItem } from 'framework/ui/BreadCrumbs';
import SingleContactsBreadcrumbs from 'domain/sales/contact/shared/SingleContactsBreadcrumbs';

const ContactRelatedOpportunitiesBreadcrumbs = () => {
  return (
    <SingleContactsBreadcrumbs>
      <BreadcrumbItem>Related Opportunities</BreadcrumbItem>
    </SingleContactsBreadcrumbs>
  );
};

export default ContactRelatedOpportunitiesBreadcrumbs;
